import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API, CATEGORIES } from "@/lib/store";
import { BikeCard } from "@/components/BikeCard";

export default function Bikes() {
  const [params, setParams] = useSearchParams();
  const [bikes, setBikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const active = params.get("category") || "all";

  useEffect(() => {
    document.title = "Buy Bikes in Mangoro Lagos | Knoble Rides Bicycle Catalog";
    setLoading(true);
    axios.get(`${API}/bikes`).then((r) => setBikes(r.data)).finally(() => setLoading(false));
  }, []);

  const setCat = (id) => {
    if (id === "all") setParams({});
    else setParams({ category: id });
  };

  const filtered = active === "all" ? bikes : bikes.filter((b) => b.category === active);
  const tabs = [{ id: "all", name: "All Bikes" }, ...CATEGORIES.map((c) => ({ id: c.id, name: c.name }))];

  return (
    <div>
      <section className="bg-[#0B0A09] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <span className="kn-overline text-[#e0b48a]">Bikes & Shop</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white sm:text-5xl">Our Bicycle Catalog</h1>
          <p className="mt-4 max-w-2xl text-lg text-zinc-300">
            Browse every bike we stock. Found one you like? Tap <span className="font-semibold text-white">Enquire on WhatsApp</span> — no cart, no checkout, just a quick chat.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="no-scrollbar flex gap-2 overflow-x-auto pb-2">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setCat(t.id)}
              data-testid={`filter-${t.id}`}
              className={`shrink-0 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
                active === t.id ? "bg-[#8C5A32] text-white" : "bg-white text-zinc-600 ring-1 ring-[#E6D7C8] hover:bg-[#FDF8F3]"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="mt-16 text-center text-zinc-500">Loading bikes…</div>
        ) : filtered.length === 0 ? (
          <div className="mt-16 text-center">
            <p className="text-zinc-500">No bikes in this category yet. Check back soon or chat with us.</p>
            <Link to="/bikes" className="mt-4 inline-block font-semibold text-[#8C5A32]">View all bikes</Link>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((b) => <BikeCard key={b.id} bike={b} />)}
          </div>
        )}
      </section>
    </div>
  );
}
